import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import { Badge } from "@tokenterminal/core/ui/messaging/badge/Badge"
import type { GetStaticProps } from "next"
import Image from "next/image"
import Link from "next/link"
import Container from "@/components/common/Container"
import Layout from "@/components/common/Layout"
import MarketingHeading from "@/components/common/MarketingHeading"
import { type CaseStudyMeta, getAllCaseStudiesMeta } from "@/utils/mdx-remote"

interface CustomersPageProps {
  caseStudies: CaseStudyMeta[]
}

export const getStaticProps: GetStaticProps<CustomersPageProps> = async () => {
  const caseStudies = getAllCaseStudiesMeta()

  return {
    props: {
      caseStudies,
    },
  }
}

const CustomersIndexPage = ({ caseStudies }: CustomersPageProps) => {
  // The sorting is now handled in the getAllCaseStudiesMeta function

  return (
    <Layout>
      <Container>
        <div className="flex justify-center my-16">
          <MarketingHeading level={1} className="text-4xl md:text-5xl">
            Customer stories
          </MarketingHeading>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {caseStudies.map((caseStudy) => (
            <Link href={`/customers/${caseStudy.slug}`} key={caseStudy.slug}>
              <Card className="w-full h-full rounded-2xl overflow-hidden flex flex-col no-underline p-0">
                <Image
                  src={caseStudy.thumbnail}
                  width={390}
                  height={245}
                  alt={caseStudy.title}
                  sizes="(max-width: 768px) 100vw, 33vw"
                  className="w-full h-auto object-cover"
                />
                <div className="flex flex-col justify-between p-6 flex-grow">
                  <div className="flex flex-col items-start gap-2">
                    <Badge
                      variant="outline"
                      size="small"
                      className="inline-block font-normal -ml-1 !text-fg-secondary"
                    >
                      {caseStudy.tag}
                    </Badge>
                    <MarketingHeading level={4} className="text-xl">
                      {caseStudy.title}
                    </MarketingHeading>
                    <p className="text-fg-secondary">{caseStudy.description}</p>
                  </div>
                  <p className="text-sm text-fg-secondary mt-5">Read more</p>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </Container>
    </Layout>
  )
}

export default CustomersIndexPage
